import { Component, Input } from "@angular/core";
import { CoreIcon } from "@svs/angular";

@Component({
  selector: "app-sidebar-back-button",
  imports: [
    CoreIcon,
  ],
  templateUrl: "./sidebar-back-button.component.html",
  styleUrl: "./sidebar-back-button.component.scss",
})
export class SidebarBackButtonComponent {

}
